import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { BaseService } from 'src/app/core/services/base.service';

@Component({
  selector: 'app-sales-order-create-dialog',
  templateUrl: './sales-order-create-dialog.component.html',
  styleUrls: ['./sales-order-create-dialog.component.scss']
})
export class SalesOrderCreateDialogComponent implements OnInit {
  form: FormGroup;
  stores: any[];
  salespersons: any[];
  salespersonCode: string;
  ledaineSalespersonCode: string;

  constructor(
    public dialogRef: MatDialogRef<SalesOrderCreateDialogComponent>,
    private fb: FormBuilder,
    private baseService: BaseService,
    public dialog: MatDialog,
  ) {
    this.form = fb.group({
      storeId: [null, Validators.compose([Validators.required])],
      salespersonCode: [null, Validators.compose([Validators.required])],
      isExternalOrder: [false, Validators.compose([])],
      externalProviderCode: [null]
    });
   }

  ngOnInit() {
    this.baseService.executeCommand<any>('portal_sales_order_create_dialog_config', {"orderType": "DRAFT"})
    .subscribe(response => {
      if (response.responseCode === 0) {
        this.stores = response.data.stores || [];
        this.salespersonCode = response.data.salespersonCode;
        this.ledaineSalespersonCode = response.data.ledaineSalespersonCode
        ;
        if (this.stores.length === 1) {
          this.form.controls['storeId'].setValue(this.stores[0].storeId);
          this.salespersons = this.stores[0].salespersons || [];

          if (this.salespersonCode) {
            if (this.salespersons.find(f => f.salespersonCode === this.salespersonCode)) {
              this.form.controls['salespersonCode'].setValue(this.salespersonCode);
            }
          }
        }
      }
    });
  }

  create(isExpressOrder: boolean) {
    const body = this.form.getRawValue();
    body.isExpressOrder = isExpressOrder;

    this.baseService.executeCommand<any>('portal_draft_order_create', body)
      .subscribe(response => {
        if (response.responseCode === 0) {
          this.dialogRef.close(response.data);
        }
      });
  }

  storeChanged() {
    this.form.controls['salespersonCode'].reset();
    this.salespersons = this.stores.find(f => f.storeId === this.form.value.storeId).salespersons || [];
    if (this.salespersonCode && this.salespersons.find(f => f.salespersonCode === this.salespersonCode)) {
      this.form.controls['salespersonCode'].setValue(this.salespersonCode);
    }
  }

  isExternalOrderChanged(isExternalOrder: MatCheckboxChange) {
    if (isExternalOrder.checked) {
      this.form.controls['externalProviderCode'].setValue('LEDAINE');
      this.form.controls['externalProviderCode'].setValidators(Validators.compose([Validators.required]));
      this.form.controls['salespersonCode'].disable();
      if (this.ledaineSalespersonCode) {
        if (this.salespersons.find(f => f.salespersonCode === this.ledaineSalespersonCode)) {
          this.form.controls['salespersonCode'].setValue(this.ledaineSalespersonCode);
        }
      }
    } else {
      this.form.controls['externalProviderCode'].reset();
      this.form.controls['externalProviderCode'].clearValidators();
      this.form.controls['salespersonCode'].enable();
      if (this.salespersonCode) {
        if (this.salespersons.find(f => f.salespersonCode === this.salespersonCode)) {
          this.form.controls['salespersonCode'].setValue(this.salespersonCode);
        }
      }
    }

    this.form.controls['externalProviderCode'].updateValueAndValidity();
    this.form.controls['salespersonCode'].updateValueAndValidity();
  }

  get canCreateExternalOrder(): boolean {
    if (!this.stores || !this.form || !this.form.value || !this.form.value.storeId) {
      return false;
    }

    const store = this.stores.find(f => f.storeId === this.form.value.storeId);
    return store ? store.canCreateExternalOrder : false;
  }

}
